import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress clone page — permanently redirect to the canonical post.
export const Route = createFileRoute("/clone-of-beard-transplants")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/beard-transplant/", location.searchStr), statusCode: 301 });
  },
});
